export const gitVersion = {
  'commit': '68d4919',
  'branch': 'Detached: 68d4919b4193ba92e134a6c8db0d80236bd28748'
};
